package org.matthewo.recharts.type

object ReferenceLineOverflow {

    val discard: ReferenceLineOverflow
        get() = "discard".unsafeCast<ReferenceLineOverflow>()

    val hidden: ReferenceLineOverflow
        get() = "hidden".unsafeCast<ReferenceLineOverflow>()

    val visible: ReferenceLineOverflow
        get() = "visible".unsafeCast<ReferenceLineOverflow>()

    val extendDomain: ReferenceLineOverflow
        get() = "extendDomain".unsafeCast<ReferenceLineOverflow>()
}
